/**
 * Kdy se to stalo — pro položku ve zvonečku.
 *
 * Požádala o to hráčka 4. 9. 2026: "jsem ve více skupinách a hru si otevřu třeba
 * ráno, nedokážu poznat, které upozornění je nové a které je ze včerejška".
 *
 * Proto NE holý čas ("9:14"), který na tu otázku neodpovídá. Odpověď je den:
 * čerstvé se počítá v minutách, dnešek dostane hodinu, včerejšek se pojmenuje a
 * starší nese datum. Nic jiného tam být nemusí.
 *
 * Den je KALENDÁŘNÍ, ne herní. Hra se sice láme ve 3:00, ale "včera" znamená
 * člověku včerejšek a notifikace není kolo — je to "Petr vstoupil do skupiny".
 */

const MINUTA = 60 * 1000;
const HODINA = 60 * MINUTA;

function sameDay(a, b) {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

/**
 * @param {string} iso  created_at z API (s posunem, viz notifications._as_prague_iso)
 * @param {function} t  i18next t()
 * @param {{now?: Date, lang?: string}} opts
 * @returns {string} popisek, nebo "" když čas není k dispozici
 */
export function notifTime(iso, t, { now = new Date(), lang = "cs" } = {}) {
  if (!iso || typeof t !== "function") return "";
  const then = new Date(iso);
  if (isNaN(then.getTime())) return "";

  const elapsed = now.getTime() - then.getTime();

  // Malý záporný rozdíl je rozejité hodiny klienta a serveru, ne budoucnost.
  // "za 3 minuty" u něčeho, co se právě stalo, vypadá jako rozbitá appka —
  // a přesně tak by to vypadalo pořád, dokud se neopravilo to ražítko na
  // backendu (viz notifications._as_prague_iso).
  if (elapsed < MINUTA) return t("notifications.justNow");
  if (elapsed < HODINA) {
    return t("notifications.minutesAgo", { n: Math.floor(elapsed / MINUTA) });
  }

  const cas = then.toLocaleTimeString(lang, { hour: "2-digit", minute: "2-digit" });
  if (sameDay(then, now)) return t("notifications.todayAt", { time: cas });

  const vcera = new Date(now.getTime());
  vcera.setDate(vcera.getDate() - 1);
  if (sameDay(then, vcera)) return t("notifications.yesterdayAt", { time: cas });

  const datum = then.toLocaleDateString(lang, { day: "numeric", month: "numeric" });
  return t("notifications.dateAt", { date: datum, time: cas });
}
